import React from 'react';

export const getPositionStyle = (index) => {
  if (index === 0) return 'bg-[#FFEA00]/20 text-[#FFEA00] border-[#FFEA00]/40 shadow-[0_0_12px_rgba(255,234,0,0.15)]';
  if (index === 1) return 'bg-slate-300/10 text-slate-300 border-slate-300/30';
  if (index === 2) return 'bg-amber-700/20 text-amber-500 border-amber-700/30';
  return 'bg-white/5 text-slate-400 border-white/10';
};

export const EmptyState = ({ icon: Icon, text }) => (
  <div className="bg-[#0a0d15] border border-white/10 p-12 text-center">
    <Icon size={40} className="mx-auto text-slate-700 mb-3" />
    <p className="text-slate-500 text-sm">{text}</p>
  </div>
);

const sizeMap = { xs: 'w-4 h-4', sm: 'w-6 h-6', md: 'w-8 h-8' };
const fontMap = { xs: 'text-[6px]', sm: 'text-[8px]', md: 'text-xs' };

export const ClubBadge = ({ logo, name, colors, size = 'sm' }) => {
  const dim = sizeMap[size] || sizeMap.sm;
  if (logo) return <img src={logo} alt={name} className={`${dim} rounded object-cover flex-shrink-0`} loading="lazy" />;
  return (
    <div className={`${dim} rounded flex items-center justify-center ${fontMap[size] || fontMap.sm} font-bold text-white flex-shrink-0`} style={{ background: colors?.primary || '#1a1a2e' }}>
      {name?.charAt(0) || '?'}
    </div>
  );
};
